<template>
  <div>
    <section class="xlrclh">
      <img
        class="top-img"
        src="../../assets/imgs/jinjiang/7/title-bg.png"
        alt=""
      />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/7/title-1.png"
            alt=""
          />
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）经营管理领军人才专项奖励对象为税收和相关经济数据统计关系均在锦江区的企业中全职工作的经营管理人才。经营管理人才主要包括公司的董事长、总经理、副总经理、财务负责人等公司高级管理人员；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）企业头部人才专项奖励对象为税收和相关经济数据统计关系均在锦江区的企业中的高级管理人员、技术业务骨干人才等；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （三）新引进高端产业人才专项奖励对象为“1+3+3”产业领域，税收和相关经济数据统计关系均在锦江区的企事业单位的人才（集团化公司派驻人员除外）。
            </div>
          </div>
        </div>
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/7/title-2.png"
            alt=""
          />
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）经营管理领军人才专项奖励申报条件：年度集中汇缴的个人年度实际经济贡献达到100万元以上的（房地产项目开发企业除外）企业；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）企业头部人才专项奖励申报条件：实施股权激励的企业；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （三）新引进高端产业人才专项奖励申报条件：新引进符合锦江区急需紧缺人才和高端人才目录标准C类及以上的企业。
            </div>
          </div>
        </div>
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/7/title-3.png"
            alt=""
          />
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）经营管理领军人才专项奖励标准。对不超过5名企业经营管理领军人才，参照其对锦江区经济、社会、行业、文化和科技等贡献程度，给予年度个人收入最高5%的奖励；每增长100万元，可增加不超过5名领军人才，单个企业累计不超过10人（商务服务企业累计不超过20人）；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）头部人才股权激励专项奖励标准。对实施股权激励的企业头部人才，按头部人才所获得股权对应净资产价值的5%，给予最高100万元奖励；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （三）新引进高端产业人才专项奖励标准。对“1+3+3”产业领域企事业单位新引进高端人才，参照其对锦江区经济、社会、行业、文化和科技等贡献程度，3年内给予年度个人收入最高5%的奖励。
            </div>
          </div>
        </div>
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/3/title-4.png"
            alt=""
          />
          <div
            class="content"
            style="
              font-size: 0.3rem;
              color: #333333;
              font-weight: 600;
              display: flex;
            "
          >
            <div class="circle"></div>
            （一）申请经营管理领军人才专项奖励应提交以下材料：
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）《锦江区经营管理领军人才专项奖励申请表》（附件1）；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）申报企业统一社会信用代码证复印件，年度纳税证明（含：企业集中汇缴的个税证明）；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （三）申报人选身份证（护照）复印件，社保缴纳证明，年度个人收入证明及个税缴纳明细；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （四）申报人选与企业签订的正式劳动（聘用）合同复印件，劳动（聘用）合同签订单位须与社会保险参保单位一致；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （五）申报人选经营管理领军人才身份证明材料，包括但不限于任职文件、公司章程等；
            </div>
          </div>
          <div class="content">
            <div class="font">（六）诚信申报承诺书。</div>
          </div>
          <div
            class="content"
            style="
              font-size: 0.3rem;
              color: #333333;
              font-weight: 600;
              display: flex;
            "
          >
            <div class="circle"></div>
            （二）头部人才股权激励专项奖励应提交以下材料：
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）《锦江区企业对头部人才股权激励奖励申请表》（附件2）；
            </div>
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （二）申报企业统一社会信用代码证复印件，年度纳税证明；
            </div>
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （三）申报企业股权激励证明，包括但不限于股东会决议、董事会决议、股权激励实施方案、股权激励协议、行权确认书、股权激励前后公司股权结构证明（工商备案的章程或者中证登的股东名册等）、专项审计报告；
            </div>
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （四）申报人选身份证（护照）复印件、社保缴纳证明、年度个税缴纳明细（注明股权确权所缴纳的个税）；
            </div>
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （五）申报人选与企业签订的正式劳动（聘用）合同复印件，劳动（聘用）合同签订单位须与社会保险参保单位一致；
            </div>
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （六）诚信申报承诺书。
            </div>
          </div>
          <div
            class="content"
            style="
              font-size: 0.3rem;
              color: #333333;
              font-weight: 600;
              display: flex;
            "
          >
            <div class="circle"></div>
            （三）新引进高端产业人才专项奖励应提交以下材料：
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）《锦江区新引进高端产业人才专项补贴申请表》；
            </div>
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （二）申报企业统一社会信用代码证复印件、年度纳税证明；
            </div>
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （三）申请人选身份证（护照）复印件、社保缴纳证明（含引进前6个月社保证明）、年度个税缴纳明细；
            </div>
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （四）申请人选符合锦江区急需紧缺人才和高端人才C类及以上标准的认定证明；
            </div>
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （五）申请人选与企业签订的正式劳动（聘用）合同复印件，劳动（聘用）合同签订单位须与社会保险参保单位一致；
            </div>
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （六）诚信申报承诺书。
            </div>
          </div>
        </div>
        <div class="sxcl">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/1/title-5.png"
            alt=""
          />
          <div class="content" style="font-weight: 600">
            通过单位住所地所属街道办事处线下申请。
          </div>
        </div>
        <div class="contact">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/1/title-6.png"
            alt=""
          />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-86624369">028-86624369</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              区委组织部（区委人才办）
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="code" src="../assets/imgs/70/code.png" />
          <img class="text" src="../assets/imgs/70/text.png" />
        </div> -->
      </div>
    </section>
    <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 100%;
    height: auto;
  }
  .technological-process {
    transform: translateY(-2.5rem);
    .rhtj {
      position: relative;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #d4e0ff;
        margin: -0.35rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        font-size: 0.26rem;
        font-weight: 500;
        color: #4e4e4e;
        text-align: left;
        line-height: 0.44rem;
        .font {
          background-color: #fff;
          border-radius: 0.2rem;
          padding: 0.28rem 0.31rem;
        }
        .circle {
          width: 0.18rem;
          height: 0.18rem;
          border-radius: 50%;
          border: 0.08rem solid #ff6d60;
          flex-shrink: 0;
          margin-right: 0.1rem;
          margin-top: 0.05rem;
        }
      }
    }

    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.3rem 0.54rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;
      }
    }
    .sbcl {
      position: relative;
      margin-top: 0.22rem;
      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.95rem auto 0;
        padding: 0.33rem 0.24rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.15rem 0.23rem 0.3rem;
          margin-top: 0.5rem;
          position: relative;
          .title {
            font-size: 0.3rem;
            font-weight: bold;
            color: #333333;
          }
          .item {
            margin-top: 0.3rem;
            box-sizing: border-box;
            position: relative;
            padding-left: 0.42rem;
            display: flex;
            .dot {
              width: 0.39rem;
              height: 0.39rem;
              background-color: #739bfe;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.28rem;
              color: #fff;
              border-radius: 50%;
              position: absolute;
              left: -0.1rem;
              top: 0;
              z-index: 9999;
            }
          }
        }
      }
    }
    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;
            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }
            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }
            .line-top {
              display: flex;
              width: 3.31rem;
              height: 0.49rem;
              background-image: url(../../assets/imgs/jinjiang/1/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.08rem;
              .line-num {
                width: 0.39rem;
                height: 0.39rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }
            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .code {
        width: 1.94rem;
        height: 1.94rem;
      }
      .text {
        height: 1.72rem;
      }
    }
  }
}
</style>
